import React, {useCallback} from 'react'
import {useTranslation} from 'react-i18next'
import {TitledBody} from '../common/components/TitledBody'
import {CPEToCreate} from '../app/types'
import {api} from '../common/api'
import {useSelector} from 'react-redux'
import {selectedSiteSelector} from '../authentication/redux'
import {useHistory} from "react-router";
import CPEFormScreen from "./CpeForm";
import {Grid} from "@mui/material";

const initialCPE: CPEToCreate = {
    model: '',
    name: '',
    macAddress: '',
    ipei: ''
}

export const Add = () => {
    const {t} = useTranslation()
    const site = useSelector(selectedSiteSelector)
    const history = useHistory()

    const onSubmit = useCallback(
        async (formData: CPEToCreate) => {
            if (!site) return
            await api.post(`/api/site/${site.productId}/cpe`, {
                ...formData,
                macAddress: formData.macAddress ? formData.macAddress.replaceAll(":", "") : null
            })
            history.push('/cpe')
        },
        [site, history],
    )

    return (
        <TitledBody title={t('cpes.add.title')}>
            <Grid container>
                <Grid item xs={12} lg={9}>
                    <CPEFormScreen cpe={initialCPE} onSubmit={onSubmit} />
                </Grid>
            </Grid>
        </TitledBody>
    )
}
